import { useQuery } from '@tanstack/react-query';
import { convertPDFBinary } from '@/libs/pdfjs-dist/utils/convertPDFBinary';

export const useGetPDFContent = (url: string | null) =>
  useQuery({
    queryKey: ['pdf', url],
    queryFn: () => getPDFContent(url!),
    enabled: !!url,
  });

const getPDFContent = async (url: string) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const arrayBuffer = await blob.arrayBuffer();
    const binary = new Uint8Array(arrayBuffer);
    const pages = await convertPDFBinary(binary);
    return { pages };
  } catch {
    return { pages: [] };
  }
};
